export const forBusiness_email_generate = [
	{
		icon: '⏳',
		title: 'generateData_title1',
		subtitle: 'generateData_subtitle1',
	},
	{
		icon: '⭐️',
		title: 'generateData_title2',
		subtitle: 'generateData_subtitle2',
	},
	{
		icon: '🌈',
		title: 'generateData_title3',
		subtitle: 'generateData_subtitle3',
	},
	{
		icon: '🚀',
		title: 'generateData_title4',
		subtitle: 'generateData_subtitle4',
	},
	{
		icon: '✌️',
		title: 'generateData_title5',
		subtitle: 'generateData_subtitle5',
	},
];
